export type TestType = 'normal' | 'special';
export interface FormData {
  testType: TestType;
  testCodes: string[];
  sampleDateTime: string;
  comment?: string;
  copyDoctors?: string[];
}
